export enum IInboxChannel {
  WHATSAPP = "whatsapp",
  INSTAGRAM = "instagram",
}
